import RoleNavigation from "./RoleNavigation";
export default function AttorneyNav() {
  return <RoleNavigation role="attorney" />;
}
